import { ActionCreatorsMapObject } from 'redux';
import { UnwrappedPromise } from '../types';

export interface IAction<T extends string> {
  type: T;
}

export interface IPayloadAction<T extends string, P> extends IAction<T> {
  payload: P;
}

// supports all actions with type and optional payload
export function createAction<T extends string>(type: T): IAction<T>;
export function createAction<T extends string, P>(
  type: T,
  payload: P
): IPayloadAction<T, P>;
export function createAction<T extends string, P>(type: T, payload?: P) {
  return payload === undefined ? { type } : { type, payload };
}

export type ActionsUnion<A extends ActionCreatorsMapObject> = ReturnType<
  A[keyof A]
>;

export interface IMap<K, V> {
  clear(): void;
  delete(key: K): boolean;
  entries(): IterableIterator<[K, V]>;
  forEach(
    callbackfn: (value: V, index: K, map: Map<K, V>) => void,
    thisArg?: any
  ): void;
  get(key: K): V;
  has(key: K): boolean;
  keys(): IterableIterator<K>;
  set(key: K, value?: V): Map<K, V>;
  size: number;
  values(): IterableIterator<V>;
  [Symbol.iterator](): IterableIterator<[K, V]>;
  [Symbol.toStringTag]: string;
}

export interface IActionPayload {
  type: string;
  payload: {
    [key: string]: any;
  };
}

export type APIResponse<T extends (...args: any) => any> = UnwrappedPromise<
  ReturnType<T>
>;

export type EntityList<T> = {
  items: T[];
  loading: boolean;
  queriedAtLeastOnce: boolean;
  total?: number;
};
